import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { TrustMarquee } from "../components/TrustMarquee";
import { ProblemSection } from "../components/ProblemSection";
import { Services } from "../components/Services";
import { TargetGroups } from "../components/TargetGroups";
import { Trust } from "../components/Trust";
import { Process } from "../components/Process";
import { Faq } from "../components/Faq";
import { ServiceArea } from "../components/ServiceArea";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { MobileBar } from "../components/MobileBar";

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="pb-[72px] md:pb-0">
        <Hero />
        <TrustMarquee />
        <ProblemSection />
        <Services />
        <TargetGroups />
        <Trust />
        <Process />
        <Faq />
        <ServiceArea />
        <ContactSection />
      </main>
      <div className="pb-[72px] md:pb-0">
        <Footer />
      </div>
      <MobileBar />
    </>
  );
}
